import { SxProps, styled } from "@mui/material";
import { ReactComponent as CircleIcon } from "../../assets/Circle.svg";

const Header = styled("h2")<{ showRedDot?: boolean }>`
	text-align: left;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	text-transform: uppercase;
	color: #113b62;
	font-family: Baloo;
	font-size: 34px;
	font-style: normal;
	font-weight: 400;
	line-height: 40px;
	margin: 15px 0px;
	position: relative;
	width: fit-content;

	svg {
		transform: translateY(-0.1rem);
		fill: #063774;
		width: 25px;
		height: auto;
	}

	::after {
		content: "";
		display: ${(props) => (props.showRedDot ? "block" : "none")};
		position: absolute;
		top: 0;
		right: -16px;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background-color: #e53939;
	}
`;

const SectionHeader = ({
	text,
	icon,
	showRedDot,

	sx
}: {
	text: string;
	icon: JSX.Element;
	showRedDot?: boolean;
	handleInfoButtonClick?: () => void;
	sx?: SxProps;
}): JSX.Element => (
	<Header sx={sx} showRedDot={showRedDot}>
		{icon ? icon : <CircleIcon />}
		{text}
	</Header>
);

export default SectionHeader;
